import styled from 'styled-components';

export const CoachInfoWrap = styled.div`
  padding: 2.4rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const TagArea = styled.div`
  display: flex;
  align-items: center;
  color: var(--color-gray-text-second);

  & > p:not(:last-of-type)::after {
    content: '|';
    padding: 0 0.5rem;
  }
`;

export const NameArea = styled.div`
  display: flex;
  justify-content: space-between;
  color: var(--color-white);
`;

export const LocationArea = styled.div`
  display: flex;
  align-items: center;
  color: var(--color-gray-text-second);

  svg {
    width: 1.25rem;
    margin-right: 0.5rem;
  }
`;

export const GradeArea = styled.div`
  display: flex;
  align-items: center;
  margin-top: -0.8rem;
  color: var(--color-gray-text-second);

  svg {
    width: 1.25rem;
    margin-right: 0.5rem;
  }

  & > p:not(:last-of-type)::after {
    content: '|';
    padding: 0 0.5rem;
  }
`;

export const Tags = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const Tag = styled.div`
  padding: 2.5px 8px;
  background-color: rgba(119, 80, 233, 0.2);
  color: #9170f2;
  font-size: 12px;
  border-radius: 22px;
`;
